import { render, staticRenderFns } from "./customer-list-grid.vue?vue&type=template&id=4e7cb814"
import script from "./customer-list-grid.vue?vue&type=script&lang=js"
export * from "./customer-list-grid.vue?vue&type=script&lang=js"
import style0 from "./customer-list-grid.vue?vue&type=style&index=0&id=4e7cb814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports